import { atsApiQuery } from '..';

export const departmentsApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getAtsDepartments: builder.query({
        providesTags: ['GetAtsDepartments'],
        transformResponse: (response) => response?.data?.departments,
        query: () => {
          return {
            method: 'get',
            url: `/ats_departments`,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const { useGetAtsDepartmentsQuery } = departmentsApi;
